import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { useNavState } from '@/lib/nav-state';
import { SignUpScreen } from '@/screens/auth/SignUpScreen';

/**
 * A Shopify app launch opens /sign-up?connector=shopify&shop=<store>. The store moves into
 * history state and the entry is replaced by plain /sign-up (no data in URLs); the screen
 * keeps it for the Connect Data step.
 */
export const Route = createFileRoute('/_auth/sign-up')({
  validateSearch: z.object({ connector: z.string().optional(), shop: z.string().optional() }),
  beforeLoad: ({ search }) => {
    if (search.connector === 'shopify' && search.shop) {
      throw redirect({ to: '/sign-up', search: {}, state: { shopifyLaunch: search.shop }, replace: true });
    }
  },
  component: SignUpRoute,
});

function SignUpRoute() {
  const { shopifyLaunch } = useNavState();
  return <SignUpScreen shopifyLaunch={shopifyLaunch} />;
}
